import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Checkbox } from 'antd'
import validateZipcode from '../../../../utils/validateZipcode'
import $t from '../../../../i18n'
import Actions from '../../../../actions'
import MaterialInput from '../../../common/MaterialInput'

import './BillingAddressSection.css'

const BillingAddressSection = ({
  locationData,
  errors,
  isEditableView,
  hideSameAsHomeAddressOption,
  isHmo,
  isHomeAddressConfirmed,
  onConfirmHomeAddress,
  title
}) => {
  const dispatch = useDispatch()
  const { isPaymentFromPPF, paymentAddressObj } = useSelector(
    state => state.payment
  )

  const locationVerificationData = useSelector(
    state => state.auth.locationVerification
  )

  const defaultBillingAddress = locationData || locationVerificationData

  const billingAddress = paymentAddressObj

  const getEmptyAddress = () => ({
    creditCardCountry: 'United States',
    creditCardAddress1: '',
    creditCardAddress2: '',
    creditCardPostalCode: '',
    creditCardState: '',
    creditCardCity: ''
  })

  const [isHomeAddressAsBillingAddress, setIsHomeAddressAsBillingAddress] =
    useState(true)

  useEffect(() => {
    isHomeAddressAsBillingAddress && !isPaymentFromPPF
      ? onBillingAddressChanged({
          creditCardCountry: 'United States',
          creditCardAddress1:
            defaultBillingAddress?.address || defaultBillingAddress?.address1,
          creditCardAddress2: defaultBillingAddress?.address2 || '',
          creditCardPostalCode:
            defaultBillingAddress?.zipcode || defaultBillingAddress?.zipCode,
          creditCardState:
            validateZipcode(
              defaultBillingAddress?.zipcode || defaultBillingAddress?.zipCode
            ) || '',
          creditCardCity: defaultBillingAddress?.city
        })
      : onBillingAddressChanged(getEmptyAddress())

    if (isHmo) {
      // in case home address not as billing address, we need to confirm it (only for hmo)
      onConfirmHomeAddress(isHomeAddressAsBillingAddress)
    }
  }, [isHomeAddressAsBillingAddress, isPaymentFromPPF])

  const onBillingAddressChanged = billingAddress => {
    dispatch(
      Actions.createAction(Actions.PAYMENT_ADDRESS_UPDATED, billingAddress)
    )
  }

  return (
    <div className='billing-address-section' data-edit={isEditableView}>
      <div className='section-title semi-bold'>
        {title || $t('pages.billing.billingHeading')}
      </div>
      <div className='address-content'>
        {!isEditableView && (
          <div className='address-minimized-content'>
            <div className='value'>{locationData?.address1} </div>
            <div className='value'> {locationData?.address2} </div>
            <div className='value'>
              {locationData?.city}, {locationData?.state}{' '}
              {locationData?.zipCode}
            </div>
          </div>
        )}
        {isEditableView && (
          <div className='address-editable-content'>
            {!isPaymentFromPPF && !hideSameAsHomeAddressOption && (
              <Checkbox
                className='billing-address-checkbox'
                onChange={() =>
                  setIsHomeAddressAsBillingAddress(
                    !isHomeAddressAsBillingAddress
                  )
                }
                checked={isHomeAddressAsBillingAddress}
              >
                <span className='billing-address-checkbox-title'>
                  {isHmo
                    ? $t('pages.billing.asBillingAddress')
                    : $t('pages.billing.sameAsDeclared')}
                </span>
              </Checkbox>
            )}
            <div className='billing-address-inputs'>
              <div className='row'>
                <MaterialInput
                  className='billing-address-input'
                  type='text'
                  value={billingAddress?.creditCardAddress1}
                  onChange={e =>
                    onBillingAddressChanged({
                      ...billingAddress,
                      creditCardAddress1: e.target.value
                    })
                  }
                  errorText={errors?.address}
                  label={$t('pages.billing.address')}
                />
                <MaterialInput
                  className='billing-address-input'
                  type='text'
                  value={billingAddress?.creditCardAddress2}
                  onChange={e =>
                    onBillingAddressChanged({
                      ...billingAddress,
                      creditCardAddress2: e.target.value
                    })
                  }
                  label={$t('pages.billing.address2')}
                />
              </div>
              <div className='row'>
                <MaterialInput
                  className='billing-address-input'
                  type='text'
                  value={billingAddress?.creditCardCity}
                  onChange={e =>
                    onBillingAddressChanged({
                      ...billingAddress,
                      creditCardCity: e.target.value
                    })
                  }
                  errorText={errors?.city}
                  label={$t('pages.billing.city')}
                />
                <MaterialInput
                  className='billing-address-input'
                  type='number'
                  value={billingAddress?.creditCardPostalCode}
                  onChange={e =>
                    onBillingAddressChanged({
                      ...billingAddress,
                      creditCardPostalCode: e.target.value,
                      creditCardState: validateZipcode(e.target.value) || ''
                    })
                  }
                  errorText={errors?.zip}
                  label={$t('dialogs.locationVerify.zip')}
                  max={99999}
                  min={0}
                />
              </div>
              <MaterialInput
                className='billing-address-input'
                type='text'
                value={billingAddress?.creditCardState}
                disabled={true}
                label={$t('dialogs.locationVerify.state')}
              />
              {isHmo &&
                !hideSameAsHomeAddressOption &&
                !isHomeAddressAsBillingAddress && (
                  <Checkbox
                    className={
                      errors?.homeConfirmed
                        ? 'billing-address-checkbox-terms error'
                        : 'billing-address-checkbox-terms'
                    }
                    onChange={() =>
                      onConfirmHomeAddress(!isHomeAddressConfirmed)
                    }
                    checked={isHomeAddressConfirmed}
                  >
                    <div className='billing-address-checkbox-title'>
                      {$t('pages.billing.confirmHomeAddress')}
                    </div>
                    <div className='billing-address-checkbox-title semi-bold'>
                      {locationData?.address1} {locationData?.address2}{' '}
                      {locationData?.city}, {locationData?.state}{' '}
                      {locationData?.zipCode}
                    </div>
                    <div className='billing-address-checkbox-title'>
                      {$t('pages.billing.confirmHomeAddressTerms')}
                    </div>
                    {errors?.homeConfirmed && (
                      <div className='billing-address-checkbox-terms-error'>
                        {errors?.homeConfirmed}
                      </div>
                    )}
                  </Checkbox>
                )}
            </div>
          </div>
        )}
      </div>
    </div>
  )
}

export default BillingAddressSection
